import ExecutePopupIdeaCard from './ExecutePopupIdeaCard';

export default ExecutePopupIdeaCard;
